import React from 'react';

import type { StackedNoteCardData } from 'shiftNotes/_types';
import collectFilledFormInstances from 'shiftNotes/helpers/collectFilledFormInstances';
import { useProfiles } from 'teamProfiles/hooks/teamApi';
import * as Styled from 'shiftNotes/styles/NotesStack.style';

import NoteFormCard from './NoteFormCard';
import StackedNoteCard from './StackedNoteCard';

interface NotesStackViewProps {
  notes: StackedNoteCardData[];
  isSpecialist?: boolean;
  canUnsyncFromEvent?: boolean;
  eventId?: string;
}

export default function NotesStackView({
  notes,
  isSpecialist,
  canUnsyncFromEvent = false,
  eventId,
}: NotesStackViewProps): JSX.Element | null {
  const { data: profiles = [] } = useProfiles();

  if (notes.length === 0) return null;

  return (
    <Styled.StackContainer data-testid="notes-stack">
      {notes.map((note) => {
        const filledForms = collectFilledFormInstances(
          note.formInstance,
          note.instantReflex?.steps
        );
        return (
          <React.Fragment key={note.id}>
            {filledForms.map((formInstance) => (
              <Styled.CardSlot key={formInstance.id}>
                <NoteFormCard
                  noteId={note.id}
                  authorName={note.authorName}
                  time={note.time}
                  formInstance={formInstance}
                />
              </Styled.CardSlot>
            ))}
            <Styled.CardSlot>
              <StackedNoteCard
                data={note}
                isSpecialist={isSpecialist}
                profiles={profiles}
                canUnsyncFromEvent={canUnsyncFromEvent}
                eventId={eventId}
              />
            </Styled.CardSlot>
          </React.Fragment>
        );
      })}
    </Styled.StackContainer>
  );
}
